var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-12" }, [
    _c("div", { staticClass: "mb-12" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "group__radio" }, [
        _c("div", { staticClass: "flex flex-wrap select-box" }, [
          _c(
            "label",
            { staticClass: "w-full text-base font-normal md:w-1/2 md:pr-3" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isInHonorOfForm,
                    expression: "isInHonorOfForm",
                  },
                ],
                attrs: { name: "honorOf", type: "radio" },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.isInHonorOfForm, false),
                },
                on: {
                  change: function ($event) {
                    _vm.isInHonorOfForm = false
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "inline-block mr-2 radio" }),
              _vm._v(" No\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "w-full text-base font-normal md:w-1/2 md:pr-3" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isInHonorOfForm,
                    expression: "isInHonorOfForm",
                  },
                ],
                attrs: { name: "honorOf", type: "radio" },
                domProps: {
                  value: true,
                  checked: _vm._q(_vm.isInHonorOfForm, true),
                },
                on: {
                  change: function ($event) {
                    _vm.isInHonorOfForm = true
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "inline-block mr-2 radio" }),
              _vm._v(" Yes\n        "),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isInHonorOfForm,
            expression: "isInHonorOfForm",
          },
        ],
      },
      [
        _c("div", { staticClass: "mb-12" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inHonorOfNameForm,
                expression: "inHonorOfNameForm",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: `${_vm.isInHonorOfForm ? "required|" : ""}max:60`,
                expression: "`${isInHonorOfForm ? 'required|' : ''}max:60`",
              },
            ],
            attrs: { id: "iho-name", name: "in memory of name", type: "text" },
            domProps: { value: _vm.inHonorOfNameForm },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inHonorOfNameForm = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("in memory of name"),
                  expression: "errors.has('in memory of name')",
                },
              ],
              staticClass: "text-lg error text-error-red",
            },
            [_vm._v(_vm._s(_vm.errors.first("in memory of name")))]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _vm._m(2),
            _vm._v(" "),
            _c("direct-upload-player", {
              attrs: { id: "iho-photo" },
              model: {
                value: _vm.inHonorOfPhotoForm,
                callback: function ($$v) {
                  _vm.inHonorOfPhotoForm = $$v
                },
                expression: "inHonorOfPhotoForm",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inHonorOfDescriptionForm,
                expression: "inHonorOfDescriptionForm",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: `${_vm.isInHonorOfForm ? "required" : ""}`,
                expression: "`${isInHonorOfForm ? 'required' : ''}`",
              },
            ],
            staticStyle: { height: "12rem" },
            attrs: {
              id: "iho-description",
              name: "in memory of description",
              type: "text",
            },
            domProps: { value: _vm.inHonorOfDescriptionForm },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inHonorOfDescriptionForm = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("in memory of description"),
                  expression: "errors.has('in memory of description')",
                },
              ],
              staticClass: "text-lg error text-error-red",
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.errors.first("in memory of description")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "border-b border-gray-medium" }),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      In Honor Of...\n      "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n        Would you like to host your event in honor of someone (or something)?\n      "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "iho-name" } }, [
      _vm._v("\n        Name "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n          Who (or what) do you want to honor? If you have multiple honorees, please separate using commas.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "iho-photo" } }, [
      _vm._v("\n        Photo\n        "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n           If you have multiple honorees, please use one photo to represent them.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "iho-description" } }, [
      _vm._v("\n        Description "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n           Tell registrants more about who (or what) you are honoring, and why.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }